import * as StoreTypes from "../DataTypes/storeTypes";
import * as LocalStripeTypes from "../DataTypes/stripeTypes";
import * as ActionGenerics from "../../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as StripeTypes from "../../../Common/Stripe/types";

export const stripe = (
    state: LocalStripeTypes.IStripe,
    action: ActionGenerics.IAction<ActionTypes.Actions>,
    initialSettings: StoreTypes.IInitialSettings
): LocalStripeTypes.IStripe => {
    switch (action.type) {
        case ActionTypes.Actions.UpdateStripeState: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, LocalStripeTypes.StripeState>;

            return {
                ...state,
                stripeState: data.parameter,
            };
        }

        case ActionTypes.Actions.SetUpdateFieldCallback: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, (value) => void>;

            return {
                ...state,
                updateFieldCallback: data.parameter,
            };
        }

        case ActionTypes.Actions.EditCreditCard: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, isCreditCardEdit: data.parameter };
        }

        case ActionTypes.Actions.UpdateCreditCard: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, StripeTypes.ICardInfo>;

            return { ...state, cardInfo: data.parameter };
        }

        case ActionTypes.Actions.SetIdempotencyKey: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, string>;

            return { ...state, idempotencyKey: data.parameter };
        }

        default:
            return state;
    }
};
